import { render, staticRenderFns } from "./CreateVersion.vue?vue&type=template&id=51cd53b2&"
import script from "./CreateVersion.vue?vue&type=script&lang=js&"
export * from "./CreateVersion.vue?vue&type=script&lang=js&"
import style0 from "./CreateVersion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports